import React from 'react';
import { Tabs } from 'antd';
import { SafetyOutlined, CompassOutlined, SafetyCertificateOutlined, SwapOutlined, AimOutlined } from '@ant-design/icons';
import SMSOtpGateSettings from './SMSOtpGateSettings';
import GeoFencingSettings from './GeoFencingSettings';
import TerminalAttestationSettings from './TerminalAttestationSettings';
import TransactionTypesSettings from './TransactionTypesSettings';
import PosTargetConfigSettings from './PosTargetConfigSettings';

const { TabPane } = Tabs;

const PosConfigSettings = () => {
  return (
    <div style={{ padding: '8px 0' }}>
      <Tabs defaultActiveKey="smsOtpConfig" type="card">
        <TabPane
          tab={
            <span>
              <SafetyOutlined />
              SMS-OTP Config
            </span>
          }
          key="smsOtpConfig"
        >
          <SMSOtpGateSettings />
        </TabPane>
        <TabPane
          tab={
            <span>
              <CompassOutlined />
              Geo-Fencing Config
            </span>
          }
          key="geoFencingConfig"
        >
          <GeoFencingSettings />
        </TabPane>
        <TabPane
          tab={
            <span>
              <SafetyCertificateOutlined />
              Terminal Attestation Config
            </span>
          }
          key="attestationConfig"
        >
          <TerminalAttestationSettings />
        </TabPane>
        <TabPane
          tab={
            <span>
              <SwapOutlined />
              Transaction Types
            </span>
          }
          key="transactionTypes"
        >
          <TransactionTypesSettings />
        </TabPane>
        <TabPane
          tab={
            <span>
              <AimOutlined />
              POS Target Config
            </span>
          }
          key="posTargetConfig"
        >
          <PosTargetConfigSettings />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PosConfigSettings;
